import restAPI from "../http-common";
import session from "./session";
import store from "@/store";

class NotificationsApi {
	get(request) {
		return restAPI({
			method: "get",
			url: "/notifications",
			params: {
				limit: request.limit,
				offset: request.offset,
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	count() {
		return restAPI({
			method: "get",
			url: "/notifications-count",
			params: {outlet_id: store.getters["user/activeOutlet"].outlet_id},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setRead(request) {
		return restAPI({
			method: "put",
			url: "/set-notifications-to-read",
			data: {notification_ids: request},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const NotificationsService = new NotificationsApi();
